<template>
  <div class="mainview">
    <div class="title">
      <i class="goback el-icon-arrow-left" @click="goback"></i>
      {{titleinfo}}
    </div>
    <div class="content whd-bgwhite" style="padding: 5px 20px"> 
      <!-- <router-link class="whd-news-item" v-for="(item,index) in activeList" :key="item.id" :to="'newsDetail?id=' + item.id" :style="index==0?'border-top: 0':''">
        {{item.title}}
        <span></span>
      </router-link>   -->
      <template v-for="(item,index) in activeList">
        <router-link class="weui-cell weui-cell__primary whd-news-item" :key="item.id" :to="'newsDetail?id=' + item.id" :style="index==0?'border-top: 0':''">
          <div class="weui-cell__bd">
            <h3>{{item.title}}</h3>
            <p>{{item.keywords}}</p>
          </div>
          <div class="weui-cell__ft">{{item.create_time}}</div>
        </router-link>
      </template>
    </div>
    <div class="pag_wrap">
      <el-pagination
        background
        :page-size="page.pagesize"
        :current-page="page.pageindex"
        layout="total, prev, pager, next"
        :total="page.total"
        @current-change="pageIndexChange"
      ></el-pagination>
    </div>    
  </div>
</template>

<script>
import api from "@/api.js";
import { pagination } from "@/util/util.js";
export default {
  name: "newsList",
  data() {
    return{
      titleinfo: "系统公告",
      page: {
        pageindex: pagination.pageIndex,
        pagesize: pagination.pageSize,
        total: pagination.total
      },
      activeList: []
    }
  },
  created() {
    this.InitFn();
  },
  methods: {
    // 分页
    pageIndexChange(pageindex) {
      this.page.pageindex = pageindex;
      this.InitFn();
    },
    goback() {
      this.$router.go(-1);
    },
    InitFn() {
      this.axios
        .post(api.companyadmin_index_newsList, {page: this.page.pageindex})
        .then(response => {
          if (response.data.code == 0) {
            this.activeList = response.data.list;
            this.page.total = response.data.all_page;
          } else {
          }
        })
        .catch(() => {});
    }
  }
}
</script>